export function retrieveUserSuccess(state, user) {
    state.user = user
    state.isRetrieved = true
}